import produce, {type Draft} from 'immer';

export const immerReducer = <S, A>(
  reducer: (state: Draft<S>, action: A) => void,
  defaultState: S
): ((state: S, action: A) => S) => {
  return (state = defaultState, action) =>
    produce(state, draft => reducer(draft, action));
};
